import Axios from 'axios'
import { getCookie } from '../utils/auth-utils'
import strings from '../strings'

const traceabilitySearchService = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.RECOLLECT_BASE_URL + '/labs/' + getCookie('profile').id_laboratory
    return AxiosInstance
  },

  getRecollects(
    patient,
    status,
    previousDays,
    offset,
    limit,
    orderByProperty,
    orderByDirection,
    osLis,
    osAlvaro,
    startDate,
    endDate
  ) {
    return this.axios().post('/recollects', {
      status: status ? status.split(',') : [],
      previousDays: previousDays,
      offset: offset,
      limit: strings.listsLimits.recollect,
      patient: patient,
      orderByProperty: orderByProperty,
      orderByDirection: orderByDirection,
      osLis: osLis,
      osAlvaro: osAlvaro,
      startDate: startDate,
      endDate: endDate
    })
  },

  getRecollectReport(data) {
    return this.axios().get(
      '/recollects/report?' +
        'startDate=' +
        data.releaseDateStart +
        '&endDate=' +
        data.releaseDateEnd +
        '&type=' +
        data.exportWay,
      { responseType: 'arraybuffer' }
    )
  },

  getTotalRecollectsNumber(patient, status, previousDays, endDate, startDate, osLis, osAlvaro) {
    return this.axios().post('/recollects/totals', {
      patient: patient,
      status: status,
      previousDays: previousDays,
      endDate: endDate,
      startDate: startDate,
      osLis: osLis,
      osAlvaro: osAlvaro
    })
  },

  getTotalRecollectsNumberForPagination(patient, status, previousDays, endDate, startDate, osLis, osAlvaro) {
    return this.axios().post('/recollects/totals', {
      patient: patient,
      status: status ? status.split(',') : [],
      previousDays: previousDays,
      endDate: endDate,
      startDate: startDate,
      osLis: osLis,
      osAlvaro: osAlvaro
    })
  },

  getRecollectByRequestId(requestId) {
    return this.axios().get('/recollects/' + requestId)
  },

  dispenseRecollect(paramsList) {
    return this.axios().put(`/recollects/${paramsList.id}?status=${paramsList.status}`)
  }
}
export default traceabilitySearchService
